import isOption from './isOption';
/**
 * return the option have the selected value from all options of the facet selection.
 * if don't have selected value we will use first option( All/Any option) as the selected option
 * @param {*} value the selected value from user
 * @param {*} options all options of the facet selection
 */
export default function getOption(value, options) {
	if (isOption(value)) {
		return value;
	}

	let newValue = value;

	// Get first option as default
	if (newValue === null && options.length) {
		const defaultOption = options[0];

		if (defaultOption) {
			newValue = defaultOption.value;
		}
	}

	return options.find((o) => o.value === newValue);
}
